// Turn an on-screen SVG into a PNG file the member can download or share
export const svgToPngBlob = (svg, width = 1600) => new Promise((resolve, reject) => {
  const xml = new XMLSerializer().serializeToString(svg);
  const url = URL.createObjectURL(new Blob([xml], { type: "image/svg+xml;charset=utf-8" }));
  const img = new Image();
  img.onload = () => {
    const [, , w, h] = svg.getAttribute("viewBox").split(" ").map(Number);
    const c = document.createElement("canvas");
    c.width = width;
    c.height = Math.round((width * h) / w);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    c.toBlob((b) => (b ? resolve(b) : reject(new Error("Couldn't create the image"))), "image/png");
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Couldn't create the image")); };
  img.src = url;
});

export const shareOrDownload = async (blob, filename, title) => {
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], title }); return "shared"; } catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  return "downloaded";
};
